import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { cn } from "@/domains/library/cn"
import { ZapCompleted } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-completed"
import { ZapFailed } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-failed"
import { ZapOnChainAction } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-on-chain-action"
import { ZapSpinner } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-spinner"
import { ZapVoltage } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-voltage"
import { zapStepMap } from "@/domains/minimal-pools-zap/components/zap/composables/zap-steps/zap-step-map"

interface ZapProgressIndicatorProps {
  store: ZapStore
  className?: string
}

export const ZapProgressIndicator = observer(({ store, className }: ZapProgressIndicatorProps) => {
  const steps = zapStepMap[store.state]

  return (
    <ul className={cn("steps w-full self-center", className)}>
      {steps.map((step) => (
        <li key={step.key} className={step.className} data-content={step.dataContent}>
          {step.customIcon === "spinner" ? <ZapSpinner /> : null}
          {step.customIcon === "completed" ? <ZapCompleted /> : null}
          {step.customIcon === "failed" ? <ZapFailed /> : null}
          {step.customIcon === "voltage" ? <ZapVoltage /> : null}
          {step.customIcon === "onchain-action" ? <ZapOnChainAction /> : null}
          {step.title}
        </li>
      ))}
    </ul>
  )
})
